import React, { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Form,
  FormControl,
  InputGroup,
  Modal,
  Row,
  Table,
} from 'react-bootstrap'
import { useGetSelectDriversQuery } from '../../redux/services/DriverService'
import {
  useAddStatementMutation,
  useEditStatementMutation,
  useGetStatementsJobsQuery,
} from '../../redux/services/StatementService'
import { sweetAlert } from '../../utils'
import { responseError } from '../../helpers/responseHandler'

import RateConModal from './RateConModal'
import PodReceipts from './PodReceipts'

const EditPayDayModal = ({ show, onHide, isEdit = null }) => {
  const { data: data2 } = useGetSelectDriversQuery()
  const drivers = data2?.response?.data

  const [editRequest, { isLoading: editLoading }] = useEditStatementMutation()
  // Static driver options
  const [selectedDriver, setSelectedDriver] = useState('')
  const [availableJobs, setAvailableJobs] = useState([])

  const [selectedJobs, setSelectedJobs] = useState([])
  const [expenses, setExpenses] = useState({
    factoring: 0.0,
    fuel: 0.0,
    insurance: 0.0,
  })
  const [customExpenses, setCustomExpenses] = useState([
    { name: 'factoring', amount: 0 },
    { name: 'fuel', amount: 0 },
    { name: 'insurance', amount: 0 },
  ])
  const [customName, setCustomName] = useState('')
  const [customAmount, setCustomAmount] = useState('')

  // Payment details
  const [paymentDate, setPaymentDate] = useState('')
  const [markPaid, setMarkPaid] = useState(false)

  // Date filter
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const [brokerName, setBrokerName] = useState('')
  const [rCName, setRCName] = useState('')

  const { data, isFetching, refetch } = useGetStatementsJobsQuery({
    id: selectedDriver,
    pagination: `?start_date=${startDate}&end_date=${endDate}`,
  })

  const jobs = data?.response?.data
  console.log('selectedData', jobs)

  // Toggle job selection
  const toggleJob = (jobId, job) => {
    setSelectedJobs(prev => {
      if (prev.includes(jobId)) {
        // Uncheck → remove from both
        setAvailableJobs(old => old.filter(j => j.id !== jobId))
        return prev.filter(id => id !== jobId)
      } else {
        // Check → add to both
        setAvailableJobs(old => [...old, { ...job }])
        return [...prev, jobId]
      }
    })
  }

  const handleAvailableJob = (jobId, field, value) => {
    setAvailableJobs(prev => prev?.map(j => (j.id == jobId ? { ...j, [field]: value } : j)))
  }

  // Filter jobs by date range
  const filteredJobs =
    jobs?.length > 0 &&
    availableJobs?.map(job => {
      return { ...job, broker_name: '', rc_number: '' }
    })

  console.log('filteredJobs', filteredJobs)

  // Calculations
  const grossEarnings =
    jobs?.length > 0 &&
    jobs.filter(job => selectedJobs?.includes(job.id)).reduce((sum, job) => sum + job.job_amount, 0)

  const totalExpenses = customExpenses.reduce((sum, e) => sum + Number(e.amount), 0)

  const netEarnings = grossEarnings - totalExpenses

  // Add custom expense
  const addCustomExpense = () => {
    if (customName && customAmount) {
      setCustomExpenses([...customExpenses, { name: customName, amount: Number(customAmount) }])
      setCustomName('')
      setCustomAmount('')
    }
  }

  const [showRateCon, setShowRateCon] = useState(false)
  const [currentRC, setCurrentRC] = useState(null)

  const [showPod, setShowPod] = useState(false)
  const [currentPod, setCurrentPod] = useState(null)
  const handleOpenRateCon = job => {
    console.log('RC Job:', job)
    setCurrentRC(job)
    setShowRateCon(true)
  }

  const handleOpenPod = job => {
    console.log('POD Job:', job)
    setCurrentPod(job)
    setShowPod(true)
  }

  const handleSave = async () => {
    const form = {
      statement_id: isEdit?.id,
      driver_id: selectedDriver,
      start_date: startDate,
      end_date: endDate,
      paid_date: paymentDate,
      is_paid: markPaid ? 1 : 0,
      expenses: customExpenses?.length > 0 ? customExpenses : [],
      available_jobs:
        availableJobs?.length > 0
          ? availableJobs?.map(job => {
              return {
                job_id: job.id,
                id: job.id,
                broker_name: job.broker_name,
                rc_number: job.rc_number,
              }
            })
          : [],
    }

    await editRequest({ id: isEdit?.id, newForm: form })
      .unwrap()
      .then(res => {
        if (res?.status) {
          sweetAlert(res?.message, 'success')
          // navigate(-1)
          onHide()
        }
      })
      .catch(err => {
        responseError(err)
      })
  }

  useEffect(() => {
    if (isEdit) {
      // Prefill driver & dates
      setSelectedDriver(isEdit.driver_id || '')
      setStartDate(isEdit.start_date || '')
      setEndDate(isEdit.end_date || '')
      setPaymentDate(isEdit.paid_date || '')
      setMarkPaid(isEdit.is_paid === 'PAID')

      // Prefill expenses
      try {
        const parsedExpenses = JSON.parse(isEdit.expenses || '[]')
        setCustomExpenses(parsedExpenses)
      } catch {
        setCustomExpenses([])
      }

      // Prefill jobs (with nested job details)
      if (isEdit.jobs?.length > 0) {
        setAvailableJobs(
          isEdit.jobs.map(j => {
            console.log('J', j)
            return {
              id: j.id, // job.id from nested job
              job_id: j.job_id,
              completed_date: j.job.completed_date,
              pickup_address: j.job.pickup_address,
              drop_address: j.job.drop_address,
              job_amount: j.job.job_amount,
              broker_name: j.broker_name,
              rc_number: j.rc_number,
              rate_confirmation_document: j?.job?.rate_confirmation_document,
              rate_confirmation_document_url: j?.job?.rate_confirmation_document_url,
            }
          })
        )

        setSelectedJobs(isEdit.jobs.map(j => j.job.id))
      }
    }
  }, [isEdit])

  console.log('available jobs', filteredJobs)

  return (
    <>
      {/* Main Payday Modal */}
      <Modal
        show={show}
        onHide={onHide}
        size='lg' // 🔹 xl ki jagah lg
        backdrop='static'
        keyboard
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Pay Day</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Driver select */}
          <Form.Group className='mb-3'>
            <Form.Label>Select Driver</Form.Label>
            <Form.Select
              value={selectedDriver}
              // onChange={(e) => setSelectedDriver(e.target.value)}
              disabled
            >
              <option value=''>-- Select Driver --</option>
              {drivers?.map(driver => (
                <option value={driver?.id}>{driver?.full_name}</option>
              ))}
            </Form.Select>
          </Form.Group>

          {selectedDriver && (
            <>
              {/* Date Filters */}
              <Row className='mb-3'>
                <Col md={6}>
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control type='date' value={startDate} disabled />
                </Col>
                <Col md={6}>
                  <Form.Label>End Date</Form.Label>
                  <div className='d-flex gap-2'>
                    <Form.Control
                      type='date'
                      value={endDate}
                      // onChange={(e) => setEndDate(e.target.value)}
                      disabled
                    />
                  </div>
                </Col>
              </Row>

              <h5>Available Jobs</h5>
              <div
                style={{
                  maxHeight: '250px',
                  overflowY: 'auto',
                  overflowX: 'auto', // 🔹 horizontal scroll hamesha on
                  whiteSpace: 'nowrap', // 🔹 columns break na ho
                }}
              >
                <Table striped bordered hover responsive>
                  <thead>
                    <tr>
                      {/*<th>
                                            <Form.Check
                                                type="checkbox"
                                                checked={selectedJobs?.length === jobs?.length}
                                                onChange={(e) =>
                                                    e.target.checked
                                                        ? setSelectedJobs(jobs.map((j) => j.id))
                                                        : setSelectedJobs([])
                                                }
                                                disabled
                                            />
                                        </th>*/}
                      <th>Job ID</th>
                      <th>Completed Date</th>
                      <th>Assigned Date</th>
                      <th>Pickup</th>
                      <th>Drop-off</th>
                      <th>Job Amount</th>
                      <th>Rate Con</th>
                      <th>POD/Receipts</th>
                      <th>Broker Name</th>
                      <th>RC Number</th>
                    </tr>
                  </thead>

                  <tbody>
                    {filteredJobs?.length > 0 &&
                      filteredJobs?.map((job, index) => (
                        <tr key={job.id}>
                          {/*<td>
                                                <Form.Check
                                                    type="checkbox"
                                                    checked={selectedJobs.includes(job.id)}
                                                    onChange={() => toggleJob(job.id, job)}
                                                    disabled
                                                />
                                            </td>*/}
                          <td>{job?.id}</td>
                          <td>{job?.completed_date}</td>
                          <td>{job.assignedDate || ''}</td>
                          <td>{job?.pickup_address}</td>
                          <td>{job?.drop_address}</td>
                          <td>${job?.job_amount}</td>
                          <td>
                            {job?.rate_confirmation_document ? (
                              <Button
                                variant='link'
                                size='sm'
                                onClick={() => handleOpenRateCon(job)}
                              >
                                View
                              </Button>
                            ) : (
                              <div className={'badge bg-danger'}>No Rate Doc</div>
                            )}
                          </td>
                          <td>
                            <Button variant='link' size='sm' onClick={() => handleOpenPod(job)}>
                              View
                            </Button>
                          </td>
                          <td>
                            <FormControl
                              placeholder='Enter broker name'
                              value={availableJobs.find(j => j.id === job.id)?.broker_name || ''}
                              onChange={e =>
                                handleAvailableJob(job.id, 'broker_name', e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <FormControl
                              placeholder='Enter RC number'
                              value={availableJobs.find(j => j.id === job.id)?.rc_number || ''}
                              onChange={e =>
                                handleAvailableJob(job.id, 'rc_number', e.target.value)
                              }
                            />
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </div>

              {/* Payday Summary */}
              <Card className='mt-4'>
                <h4 className='p-3'>Payday Summary</h4>
                <Card.Body>
                  <Row>
                    {/* Expenses Section with scroll */}
                    <Col md={6}>
                      <Row className='mb-2'>
                        <Col>
                          <strong>Gross Earnings:</strong>
                        </Col>
                        <Col className='text-end text-success fw-bold'>
                          ${parseFloat(grossEarnings).toFixed(2)}
                        </Col>
                      </Row>

                      <h6 className='mt-3'>Expenses</h6>
                      <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                        <Row className='mb-2'>
                          <Col>Factoring:</Col>
                          <Col className='text-end'>
                            <InputGroup size='sm' className='w-50 ms-auto'>
                              <InputGroup.Text>$</InputGroup.Text>
                              <FormControl
                                type='number'
                                value={customExpenses?.[0]?.amount || ''}
                                onChange={e =>
                                  setCustomExpenses(prev => {
                                    const updated = [...prev]
                                    if (updated[0]) {
                                      updated[0] = {
                                        ...updated[0],
                                        amount: e.target.value,
                                      }
                                    } else {
                                      updated.push({ amount: e.target.value })
                                    }
                                    return updated
                                  })
                                }
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col>Fuel:</Col>
                          <Col className='text-end'>
                            <InputGroup size='sm' className='w-50 ms-auto'>
                              <InputGroup.Text>$</InputGroup.Text>
                              <FormControl
                                type='number'
                                value={customExpenses?.[1]?.amount || ''}
                                onChange={e =>
                                  setCustomExpenses(prev => {
                                    const updated = [...prev]
                                    if (updated[1]) {
                                      updated[1] = {
                                        ...updated[1],
                                        amount: e.target.value,
                                      }
                                    } else {
                                      updated.push({ amount: e.target.value })
                                    }
                                    return updated
                                  })
                                }
                              />
                            </InputGroup>
                          </Col>
                        </Row>
                        <Row className='mb-2'>
                          <Col>Insurance:</Col>
                          <Col className='text-end'>
                            <InputGroup size='sm' className='w-50 ms-auto'>
                              <InputGroup.Text>$</InputGroup.Text>
                              <FormControl
                                type='number'
                                value={customExpenses?.[2]?.amount || ''}
                                onChange={e =>
                                  setCustomExpenses(prev => {
                                    const updated = [...prev]
                                    if (updated[2]) {
                                      updated[2] = {
                                        ...updated[2],
                                        amount: e.target.value,
                                      }
                                    } else {
                                      updated.push({ amount: e.target.value })
                                    }
                                    return updated
                                  })
                                }
                              />
                            </InputGroup>
                          </Col>
                        </Row>

                        {customExpenses?.slice(3)?.map((exp, idx) => (
                          <Row className='mb-2' key={idx}>
                            <Col className='text-capitalize'>{exp.name}:</Col>
                            <Col className='text-end'>
                              <InputGroup size='sm' className='w-50 ms-auto'>
                                <InputGroup.Text>$</InputGroup.Text>
                                <FormControl value={exp.amount} readOnly />
                              </InputGroup>
                            </Col>
                          </Row>
                        ))}
                      </div>

                      {/* Custom Expense Input */}
                      <Row className='align-items-center mt-3'>
                        <Col>
                          <FormControl
                            placeholder='Custom Expense Name'
                            value={customName}
                            onChange={e => setCustomName(e.target.value)}
                          />
                        </Col>
                        <Col>
                          <InputGroup>
                            <InputGroup.Text>$</InputGroup.Text>
                            <FormControl
                              type='number'
                              placeholder='Amount'
                              value={customAmount}
                              onChange={e => setCustomAmount(e.target.value)}
                            />
                          </InputGroup>
                        </Col>
                        <Col xs='auto'>
                          <Button onClick={addCustomExpense}>Add</Button>
                        </Col>
                      </Row>
                    </Col>

                    {/* Final Summary */}
                    <Col md={6}>
                      <Row className='mb-2'>
                        <Col>
                          <strong>Total Expenses:</strong>
                        </Col>
                        <Col className='text-end text-danger fw-bold'>
                          ${parseFloat(totalExpenses)?.toFixed(2)}
                        </Col>
                      </Row>
                      <Row className='mb-3'>
                        <Col>
                          <strong>Net Earnings:</strong>
                        </Col>
                        <Col className='text-end fw-bold text-primary fs-5'>
                          ${netEarnings.toFixed(2)}
                        </Col>
                      </Row>
                      <hr />
                      {isEdit.is_paid == 'PAID' ? (
                        <>
                          <label htmlFor=''>Payment Date</label>
                          <Form.Control type='date' value={paymentDate} className='mb-2' disabled />
                          <Form.Check
                            type='checkbox'
                            label='Mark as Paid'
                            checked={markPaid}
                            disabled
                          />
                        </>
                      ) : (
                        <>
                          <label htmlFor=''>Payment Date</label>
                          <Form.Control
                            type='date'
                            value={paymentDate}
                            onChange={e => setPaymentDate(e.target.value)}
                            className='mb-2'
                          />
                          <Form.Check
                            type='checkbox'
                            label='Mark as Paid'
                            checked={markPaid}
                            onChange={e => setMarkPaid(e.target.checked)}
                          />
                        </>
                      )}
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={onHide}>
            Cancel
          </Button>
          <Button variant='primary' onClick={handleSave} disabled={!selectedDriver || editLoading}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      {/* 🔹 Attach Reusable Modals */}
      <RateConModal
        show={showRateCon}
        onHide={() => setShowRateCon(false)}
        documentUrl={currentRC?.rate_confirmation_document_url}
      />

      <PodReceipts
        show={showPod}
        onHide={() => setShowPod(false)}
        documents={
          currentPod?.job_trip_documents?.length > 0
            ? currentPod.job_trip_documents.filter(d => d.type === 'DROPOFF')
            : []
        }
      />
    </>
  )
}

export default EditPayDayModal
